import React, { useEffect, useRef, ReactNode } from 'react';

interface FadeInSectionProps {
  children: ReactNode;
  className?: string;
  delay?: '' | 'fade-in-delay-1' | 'fade-in-delay-2' | 'fade-in-delay-3' | 'fade-in-delay-4';
  onClick?: () => void;
}

const FadeInSection: React.FC<FadeInSectionProps> = ({ children, className = '', delay = '', onClick }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    const el = ref.current;
    if (el) {
      observer.observe(el);
      // Check if already in viewport
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        el.classList.add('visible');
      }
    }

    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);

  return (
    <div ref={ref} className={`fade-in ${delay} ${className}`} onClick={onClick}>
      {children}
    </div>
  );
};

export default FadeInSection;
